module.exports = __webpack_public_path__ + "img/map-marker-pic.ad350cd2.svg";